import { Injectable, Injector, inject } from '@angular/core';
import {
  CoreActionGotoNextActivity,
  CoreBackendIDs,
  CoreHttpClient,
  CoreMobiResourceType,
  CORE_BACKEND
} from '@bepatient/core';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { forkJoin, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { QuestionsV3, QuestionV3ControlTypes } from '../classes/enum';
import { DatetimeQuestionV3 } from '../classes/question-datetime';
import { FieldsBlocQuestionV3 } from '../classes/question-fieldsBloc';
import {
  FormV3,
  FormV3Activity,
  FormV3InvalidField
} from './../models/dynamic-form-v3.models';
import { DynamicFormQuestionControlServiceV3 } from './question-control.service';
import { DynamicFormQuestionParserServiceV3 } from './question-parser.service';

@Injectable()
export class DynamicFormV3UtilsService {
  private http = inject(CoreHttpClient);
  private qcs = inject(DynamicFormQuestionControlServiceV3);
  private parser = inject(DynamicFormQuestionParserServiceV3);
  private injector = inject(Injector);
  private store = inject<Store<any>>(Store);

  private updatePageSource = new Subject<number>();
  updatePage$: Observable<any> = this.updatePageSource.asObservable();

  apiQuestions = [
    // {
    //   page: 0,
    //   css: {
    //     color: '',
    //     'font-size': '',
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'text-align': 'left'
    //   },
    //   name: 'html_fld_1',
    //   type: 'richtext',
    //   is_headline: true,
    //   text: 'Sliders with multiple options',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [{ message: '', required: false }]
    // },
    {
      page: 0,
      name: 'fld_1174',
      type: 'datetime',
      format: 'dd/mm/yyyy HH:mm',
      label: 'DATETIME 24hr format (dd/mm/yyyy HH:mm)',
      constraints: [{ message: 'is required', required: true }]
    },
    {
      page: 0,
      name: 'fld_1175',
      type: 'datetime',
      format: 'dd/mm/yyyy hh:mm',
      label: 'DATETIME 12hr format (dd/mm/yyyy hh:mm)',
      constraints: [{ message: 'is required', required: true }]
    },
    {
      page: 0,
      name: 'fld_1176',
      type: 'date',
      format: 'dd/mm/yyyy',
      label: 'DATE (dd/mm/yyyy)',
      constraints: [{ message: 'is required', required: true }]
    },
    {
      page: 0,
      name: 'fld_1177',
      type: 'time',
      format: 'HH:mm',
      label: 'TIME 24hr format',
      constraints: [{ message: 'is required', required: true }]
    },
    {
      page: 0,
      name: 'fld_1178',
      type: 'time',
      format: 'hh:mm',
      label: 'TIME 12hr format',
      constraints: [{ message: 'is required', required: true }]
    }
    // {
    //   page: 0,
    //   name: 'fld_1175',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'integer',
    //   label:
    //     '2. Do not display slider value but display boundary value with description & graduation',
    //   default: 0,
    //   display_value: true,
    //   use_slider: 1,
    //   options: {},
    //   show_graduation: true,
    //   step: 5,
    //   show_value: false,
    //   compulsory_condition: '',
    //   display_condition: ``,
    //   // boundary_condition: `fld_1179 == '10'`,
    //   min_value: 0,
    //   max_value: 100,
    //   min_label: 'Minimum label',
    //   max_label: 'Maximum label',
    //   constraints: [
    //     { message: 'is required', required: true },
    //     { min: 0, max: 100, message: 'value should be between 0 and 100' }
    //   ]
    // },
    // {
    //   page: 0,
    //   name: 'fld_1176',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'integer',
    //   label:
    //     '3. Display slider value, boundary value without description and no graduation',
    //   default: 0,
    //   display_value: true,
    //   use_slider: 1,
    //   options: {},
    //   show_graduation: false,
    //   step: 5,
    //   show_value: true,
    //   compulsory_condition: '',
    //   display_condition: ``,
    //   // boundary_condition: `fld_1179 == '10'`,
    //   min_value: 0,
    //   max_value: 100,
    //   min_label: '',
    //   max_label: '',
    //   constraints: [
    //     { message: 'is required', required: true },
    //     { min: 0, max: 100, message: 'value should be between 0 and 100' }
    //   ]
    // },
    // {
    //   page: 0,
    //   name: 'fld_1177',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'integer',
    //   label: '4. Display slider value and boundary value with graduation',
    //   default: 0,
    //   display_value: true,
    //   use_slider: 1,
    //   options: {},
    //   show_graduation: true,
    //   step: 1,
    //   show_value: true,
    //   compulsory_condition: '',
    //   display_condition: ``,
    //   // boundary_condition: `fld_1179 == '10'`,
    //   min_value: 2,
    //   max_value: 10,
    //   min_label: '',
    //   max_label: '',
    //   constraints: [
    //     { message: 'is required', required: true },
    //     { min: 2, max: 10, message: 'value should be between 2 and 10' }
    //   ]
    // },
    // {
    //   page: 0,
    //   css: {
    //     color: '',
    //     'font-size': '',
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'text-align': 'left'
    //   },
    //   name: 'html_fld_2',
    //   type: 'richtext',
    //   is_headline: false,
    //   text: '5. Question title in <b><i>HTML</i> field</b>?',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [{ message: '', required: false }]
    // },
    // {
    //   page: 0,
    //   name: 'fld_1179',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'integer',
    //   // label: 'Do not display slider value, boundary value, but display boundary label & graduation',
    //   label: '',
    //   default: 0,
    //   display_value: true,
    //   use_slider: 1,
    //   options: {},
    //   show_graduation: true,
    //   step: 5,
    //   show_value: true,
    //   compulsory_condition: '',
    //   display_condition: ``,
    //   // boundary_condition: `fld_1179 == '10'`,
    //   min_value: 0,
    //   max_value: 100,
    //   min_label: 'Minimum label',
    //   max_label: 'Maximum label',
    //   constraints: [
    //     { message: 'is required', required: true },
    //     { min: 0, max: 100, message: 'value should be between 0 and 100' }
    //   ]
    // },
    // {
    //   page: 0,
    //   name: 'fld_1178',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'integer',
    //   label: '6. Here a range (integer) 0 - 100',
    //   default: 0,
    //   display_value: true,
    //   use_slider: 0,
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   min_value: 50,
    //   max_value: 100,
    //   constraints: [
    //     { message: 'is required', required: true },
    //     { min: 50, max: 100, message: 'value should be between 50 and 100' }
    //   ]
    // },
    // {
    //   page: 0,
    //   name: 'fld_1180',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'number', // it can be change
    //   label: '7. Number Field Required',
    //   options: {},
    //   compulsory_condition: 'fld_1178 == 60',
    //   display_condition: 'fld_1178 >= 50',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     },
    //     { min: 0, max: 80, message: 'Value should be between 0 and 80' },
    //     { max_length: 2, message: '2 maximum authorized digit(s)' }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1181',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'number', // it can be change
    //   label: '8. Always visible number',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     },
    //     { min: 0, max: 80, message: 'Value should be between 0 and 80' },
    //     { max_length: 2, message: '2 maximum authorized digit(s)' }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1182',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'number', // it can be change
    //   label: '9. Conditional number',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: 'fld_1178 == 60',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     },
    //     { min: 0, max: 80, message: 'Value should be between 0 and 80' },
    //     { max_length: 2, message: '2 maximum authorized digit(s)' }
    //   ]
    // }
    // {
    //   page: 0,
    //   name: 'fld_1181',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'decimal', // it can be change
    //   label: 'Decimal Field (6 digits max)',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     { message: 'is required', required: true },
    //     { max_length: 6, message: '6 maximum authorized digit(s)' }
    //   ]
    // },
    // {
    //   page: 0,
    //   name: 'fld_1182',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'date', // it can be change
    //   label: 'Date Field 1182',
    //   format: 'dd/mm/yyyy HH:mm',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 0,
    //   name: 'fld_1183',
    //   type: 'select',
    //   css: {},
    //   label: 'Here a drop-down list',
    //   options: {
    //     0: { value: 'CODE1246', label: 'Option 1' },
    //     1: { value: 'CODE1247', label: 'Option 2' },
    //     2: { value: 'CODE1248', label: 'Option 3' },
    //     3: { value: 'CODE1249', label: 'Option 4' }
    //   },
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [{ message: 'is required', required: true }]
    // },
    // {
    //   page: 0,
    //   name: 'fld_1177',
    //   type: 'select',
    //   css: {},
    //   label: 'Here a multiple drop-down list',
    //   options: {
    //     0: { value: 'CODE1246', label: 'Option 1' },
    //     1: { value: 'CODE1247', label: 'Option 2' },
    //     2: { value: 'CODE1248', label: 'Option 3' },
    //     3: { value: 'CODE1249', label: 'Option 4' }
    //   },
    //   multiple: '1',
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [{ message: 'is required', required: true }]
    // },
    // {
    //   page: 0,
    //   name: 'fld_1184',
    //   type: 'textarea',
    //   css: {},
    //   label: 'Text Area',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [{ message: 'is required', required: true }]
    // },
    // {
    //   page: 0,
    //   name: 'fld_1185',
    //   type: 'radio',
    //   css: {},
    //   label: 'Option Group',
    //   options: {
    //     0: { value: 'YES', label: 'Yes', image_src: '' },
    //     1: { value: 'NO', label: 'No', image_src: '' },
    //     2: { value: 'DONTKNOW', label: "Don't know", image_src: '' }
    //   },
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [{ message: 'is required', required: true }]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1186',
    //   type: 'checkbox',
    //   css: {},
    //   label: 'Simple Checkbox',
    //   options: {
    //     0: { value: '1', label: 'True', image_src: '' },
    //     1: { value: '2', label: 'False', image_src: '' },
    //     2: { value: '3', label: 'No Answer', image_src: '' }
    //   },
    //   compulsory_condition: '',
    //   display_condition: 'fld_1174 > 3',
    //   constraints: [{ message: 'is required', required: true }]
    // }
    // {
    //   page: 0,
    //   name: 'fld_1187',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'email', // it can be change
    //   label: 'Your Email',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1188',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'signature_pad', // it can be change
    //   label: 'Signature of the participant',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1189',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'photo', // it can be change
    //   label: 'Photo Field',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     },
    //     {
    //       message: 'maximum file size is 10 Mb',
    //       max_size: 10
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1190',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'file', // it can be change
    //   label: 'File Field',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1191',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'toggle', // it can be change
    //   label: 'Toggle Field',
    //   options: {
    //     0: { value: '1', label: 'Toggle Field 1', image_src: '' }
    //   },
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1192',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'social_security', // it can be change
    //   label: 'Social Security',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1193',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'text', // it can be change
    //   label: 'Simple text 2.1',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1194',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'text', // it can be change
    //   label: 'Simple text 2.2',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1195',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'text', // it can be change
    //   label: 'Simple text 2.3',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1196',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'text', // it can be change
    //   label: 'Simple text 2.4',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1197',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'text', // it can be change
    //   label: 'Simple text 2.5',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   page: 1,
    //   name: 'fld_1198',
    //   css: {
    //     'font-weight': '',
    //     'font-style': '',
    //     size: '',
    //     'font-size': '',
    //     color: ''
    //   },
    //   type: 'text', // it can be change
    //   label: 'Simple text 2.6',
    //   options: {},
    //   compulsory_condition: '',
    //   display_condition: '',
    //   constraints: [
    //     {
    //       message: 'is required',
    //       required: true
    //     }
    //   ]
    // }
  ];

  /**
   * Without value
   * */
  // apiAnswers = {
  //   uuid: '1589',
  //   mtime: '',
  //   status: 'done',
  //   last_author: '',
  //   responses: [
  //     { uuid: 'fld_1177', value: '' },
  //     { uuid: 'fld_1178', value: '' },
  //     { uuid: 'fld_1179', value: '' },
  //     { uuid: 'fld_1180', value: '' },
  //     { uuid: 'fld_1181', value: '' },
  //     { uuid: 'fld_1182', value: '' },
  //     { uuid: 'fld_1183', value: '' },
  //     { uuid: 'fld_1184', value: '' },
  //     { uuid: 'fld_1185', value: '' },
  //     { uuid: 'fld_1186', value: '' },
  //     { uuid: 'fld_1187', value: '' },
  //     { uuid: 'fld_1188', value: '' },
  //     { uuid: 'fld_1189', value: '' },
  //     { uuid: 'fld_1190', value: '' },
  //     { uuid: 'fld_1191', value: '' },
  //     { uuid: 'fld_1192', value: '' }
  //   ]
  // };

  /**
   * With value
   * */

  apiAnswers = {
    uuid: '1589',
    mtime: '',
    status: 'done',
    last_author: '',
    responses: [
      // { uuid: 'fld_1177', value: '' },
      // { uuid: 'html_fld_1', value: '' },
      { uuid: 'fld_1174', value: '' },
      { uuid: 'fld_1175', value: '' },
      { uuid: 'fld_1176', value: '' },
      { uuid: 'fld_1177', value: '' },
      { uuid: 'fld_1178', value: '' }
      // { uuid: 'fld_1177', value: '' },
      // { uuid: 'html_fld_2', value: '' },
      // { uuid: 'fld_1178', value: '68' },
      // { uuid: 'fld_1179', value: '50' },
      // { uuid: 'fld_1180', value: '12' },
      // { uuid: 'fld_1181', value: '5' },
      // { uuid: 'fld_1182', value: '' }
      // { uuid: 'fld_1182', value: '07/02/2022' },
      // { uuid: 'fld_1183', value: ['CODE1247'] },
      // { uuid: 'fld_1184', value: 'example text' },
      // { uuid: 'fld_1185', value: 'NO' },
      // { uuid: 'fld_1186', value: [''] }
      // { uuid: 'fld_1187', value: '' },
      // { uuid: 'fld_1188', value: '' },
      // { uuid: 'fld_1189', value: '' },
      // { uuid: 'fld_1190', value: '' },
      // { uuid: 'fld_1191', value: ['1'] },
      // { uuid: 'fld_1192', value: '' },
      // { uuid: 'fld_1193', value: '' },
      // { uuid: 'fld_1194', value: '' },
      // { uuid: 'fld_1195', value: '' },
      // { uuid: 'fld_1196', value: '' },
      // { uuid: 'fld_1197', value: '' },
      // { uuid: 'fld_1198', value: '' }
    ]
  };

  /**
   * Load Form data
   * @param url
   * @param selectedActivityUuid
   * @param bypassSelectedActivityLoading
   * @returns
   */
  loadFormFromMOBI(
    url: string,
    selectedActivityUuid?: string,
    bypassSelectedActivityLoading = false
  ): Observable<any> {
    return this.http.get(url, { withMobiCredentials: true }).pipe(
      // Note: Enable this to test using dummy data
      // return of({
      //   uuid: '1214',
      //   title: 'Mocked Form - Datetime Fields',
      //   image: '',
      //   color: '#093520',
      //   can_edit: true,
      //   can_repeat: true,
      //   class_id: '',
      //   questions: this.apiQuestions,
      //   answers: this.apiAnswers,
      //   message_popup_required_field_missing:
      //     'Required fields are missing. Click OK to fill out fields with red flag.',
      //   message_popup_maxlength_exceeded:
      //     'Number of exceeded digits were detected. Click OK to correct your answers to the questions with red flag.',
      //   message_popup_limit_exceeded:
      //     'Field value must be within authorized limit',
      //   message_popup_form_field_error:
      //     'Some field values are missing or with errors. Please correct them before submit.'
      // }).pipe(
      map((res: any) => {
        let meta = res.meta || {};
        if (this.injector.get(CORE_BACKEND) === CoreBackendIDs.SMART) {
          meta = res.payload;
          // meta = res;
        }
        return {
          abspath: meta.abspath || '',
          activitiesUuid: selectedActivityUuid ? [selectedActivityUuid] : [],
          uuid: meta.uuid || '',
          title: meta.title || '',
          image: meta.image || '',
          color: meta.color || '',
          canEdit: meta.can_edit || false,
          canRepeat: meta.can_repeat || false,
          classId: meta.class_id || '',
          currentPage: 0,
          prevPage: null,
          skip: undefined,
          invalidFields: [],
          intPageOccurrence: meta.intPageOccurrence || 0,
          questions: meta.questions || [],
          activities: [meta.answers], // TODO: Incase of multiple activity ???
          messagePopupFormFieldError:
            meta.message_popup_form_field_error ||
            'Sorry, we are working on it...'
        };
      }),
      map((formData: any) => {
        const questions: QuestionsV3[] = this.qcs.questionBuilder(
          this.parser.parseQuestions(formData.questions)
        );

        // TODO: Incase of multiple activity ???
        const activities: FormV3Activity[] = [
          {
            ...formData.activities[formData.activities.length - 1],
            readonly: bypassSelectedActivityLoading
              ? false
              : !formData.canEdit && !formData.canRepeat,
            responses: this.qcs.setFormValue(
              this.parser.patientProfileParseResponses(
                formData.questions,
                formData.activities[formData.activities.length - 1].responses
              ),
              questions
            )
          }
        ];

        const questionPages: QuestionsV3[][] = questions
          .sort((a, b) => a.page - b.page)
          .reduce(
            (acc, cur) => {
              cur.page === acc.length - 1
                ? acc[acc.length - 1].push(cur)
                : acc.push([cur]);

              return acc;
            },
            [[]]
          );

        return {
          ...formData,
          activities,
          questionPages,
          canChangeActivity: !(
            !!selectedActivityUuid || activities.length <= 1
          ),
          selectedActivity:
            activities.find(
              activity => activity.uuid === selectedActivityUuid
            ) || activities[0]
        };
      })
    );
  }

  updatePageData(form: FormV3) {
    this.updatePageSource.next(form.currentPage);
  }

  saveFormToMOBI(form: FormV3, addCurrentPage = true): Observable<any> {
    /**
     * As of form V3, form.selectedActivity.responses object's contains string keyed property [key, value] pairs.
     * key = page index/page number and value = form data of each page
     * So, need to merge all pages formData into one object.
     */
    // let formattedResponse = {};
    // form &&
    //   form.selectedActivity &&
    //   form.selectedActivity.responses &&
    //   Object.entries(form.selectedActivity.responses).map(
    //     ([pageIndex, page]) => {
    //       Object.assign(formattedResponse, page);
    //     }
    //   );

    let data = this.parser.parseFormValuesForMobi(
      form.selectedActivity.responses,
      form.questionPages.reduce((acc, cur) => acc.concat(cur), [])
    );

    const smart = this.injector.get(CORE_BACKEND) === CoreBackendIDs.SMART;
    const url = form.classId.includes('profile-form')
      ? smart
        ? '/rest/users/me/profile'
        : '/api/users/me/profile'
      : smart
      ? '/rest/contents/forms'
      : '/api/contents/forms';

    return (
      form.selectedActivity.uuid
        ? of(form.selectedActivity.uuid)
        : this.createNewActivity(url, form)
    ).pipe(
      switchMap(activityUuid =>
        this.saveAnswers(url, form, activityUuid, addCurrentPage, data)
      )
    );
  }

  saveFormContactToMOBI(form: FormV3): Observable<any> {
    const data = this.parser.parseFormValuesForMobi(
      form.selectedActivity.responses,
      form.questionPages.reduce((acc, cur) => acc.concat(cur), [])
    );

    return this.http
      .post(`/api/contact`, data, {
        withMobiCredentials: true
      })
      .pipe(
        catchError(err =>
          throwError(
            err.error && err.error.messages
              ? Object.keys(err.error.messages).map<FormV3InvalidField>(
                  questionKey => ({
                    questionKey,
                    messages: err.error.messages[questionKey]
                  })
                )
              : void 0
          )
        )
      );
  }

  private generateNewProformActivity(questions: QuestionsV3[]): FormV3Activity {
    return {
      uuid: void 0,
      date: void 0,
      done: false,
      readonly: true,
      lastAuthor: void 0,
      dataToCheck: [],
      hideSelector: true,
      responses: questions.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]:
            cur.controlType === QuestionV3ControlTypes.CHECKBOX ||
            cur.controlType === QuestionV3ControlTypes.MULTI_DROPDOWN
              ? []
              : ''
        }),
        {}
      )
    };
  }

  private saveAnswers(
    url: string,
    form: FormV3,
    activityUuid: string,
    addCurrentPage: boolean,
    data: any
  ): Observable<any> {
    // SMARTAPP-167: Send backend, Form last page status when form is updated
    // If currentPage is lastPage (nth Page)
    // or CurrentPage is lastPage when all pages after current page have skip status true
    let noMorePages: boolean = false;
    let pagesAfterCurrentPage: Array<boolean>;
    if (
      form &&
      form.skip &&
      form.skip.length > 0 &&
      form.currentPage < form.questionPages.length
    ) {
      // Get all pages skip status after current page
      pagesAfterCurrentPage = form.skip.slice(form.currentPage + 1);
      // Check if all the pages after current page are skipped and set noMorePages true/false
      noMorePages = pagesAfterCurrentPage.every(
        skipStatus => skipStatus === true
      );
    }

    noMorePages == true
      ? (data = {
          ...data,
          intPageOccurrence: form.intPageOccurrence,
          is_form_fully_completed: true
        })
      : (data = {
          ...data,
          intPageOccurrence: form.intPageOccurrence,
          is_form_fully_completed: false
        });

    return this.http
      .put(
        `${url}/${form.uuid}/answers/${activityUuid}`,
        addCurrentPage ? { ...data, page: form.currentPage } : data,
        {
          withMobiCredentials: true
        }
      )
      .pipe(
        tap((response: any) => {
          const payload = response.payload;
          const convertResource = (type: string, href: string) => {
            switch (type) {
              case 'activity-form':
                return { type: CoreMobiResourceType.FORM, href };
              case 'activity-category':
                return { type: CoreMobiResourceType.CATEGORY, href };
              case 'activity-factsheet':
                return { type: CoreMobiResourceType.FACTSHEET, href };
              default:
                return void 0;
            }
          };
          const resource = convertResource(payload.type, payload.href);
          this.store.dispatch(new CoreActionGotoNextActivity(resource));
        }),
        catchError(err =>
          throwError(
            err.error && err.error.messages
              ? Object.keys(err.error.messages).map<FormV3InvalidField>(
                  questionKey => ({
                    questionKey,
                    messages: err.error.messages[questionKey]
                  })
                )
              : void 0
          )
        )
      );
  }

  private createNewActivity(url: string, form: FormV3): Observable<string> {
    return this.http
      .post(`${url}/${form.uuid}/answers`, {}, { withMobiCredentials: true })
      .pipe(
        map((res: any) => {
          const match = res.location.match(/answers\/(\w+)?/);
          return match.length === 2
            ? (form.selectedActivity.uuid = match[1])
            : void 0;
        })
      );
  }
}
